import React from 'react';
import { action } from 'mobx'
import { observer } from 'mobx-react';

// Config
import { setToken } from '../../config';

// Helpers
import { getUrlSegment, storeData } from '../../helpers/helpers';

// Translation
import translate from '../translate/Translate';

const Authenticate = observer(class Authenticate extends React.Component {
  componentDidMount() {
    const { AppStore } = this.props.store;

    // Marks as shared viewer to hide the share button
    action(() => {
      AppStore.sharedViewer = true;
    })();

    // Also mark as a shared viewer in session storage
    storeData('sharedViewer', true);
  }

  authenticate = (e) => {  
    e.preventDefault();

    const { history, store } = this.props;
    const { AppStore } = store;
    const shareSid = getUrlSegment(2);
    
    const callback = (response) => {
      // Store the token
      storeData('token', response.token);

      // Add the token to the API headers
      setToken(response.token);

      // Redirect to the playback view
      history.push(`/?installSid=${response.installSid}&examSid=${response.examSid}&sessionSid=${response.sessionSid}`)
    }
    
    AppStore.authenticate(shareSid, callback)
  }

  render() {
    const { store, translation } = this.props;
    const { AppStore } = store;
    
    return (
      <div className="panel panel--sm panel--solo">
        <h1 className="panel__title">
          {translation.heading}
        </h1>

        <p>
          {translation.body}
        </p>

        <form
          className="form form--inline"
          onSubmit={e => this.authenticate(e)}
        >
          <fieldset>
            <label
              className="form__lbl required"
              htmlFor="share-password"
            >
              {translation.password.label}
            </label>
          
            <input
              aria-required="true"
              data-errormsg={translation.password.error}
              id="share-password"
              onChange={e => AppStore.passwordInput = e.target.value}
              required
              type="password"
              value={AppStore.passwordInput}
            />
          </fieldset>
      
          <button
            className="btn"
            type="submit"
          >
            {translation.submit}
          </button>
        </form>
      </div>
    )
  }
})

export default translate('Authenticate')(Authenticate);
